import { ButtonWithDialog } from "@focus/focusUI";
import { useMemo, useState } from "react";
import { usePhonebook } from "../../hooks/usePhonebook";
import { ROLES, useRoles } from "../../hooks/useRoles";
import type { Organization } from "../../types/phonebook";
import { PhonebookOrganizationForm } from "./PhonebookOrganizationForm";
import { useMe } from "../../hooks/useMe";

export const EditOrganizationButton = ({
  organization,
}: {
  organization: Organization;
}) => {
  const me = useMe();
  const { updateOrganization } = usePhonebook();
  const { roles } = useRoles();
  const [isInvalid, setIsInvalid] = useState(true);
  const canEditRestrictedOrgFields = roles.includes(ROLES.ADMIN);

  const canEdit = useMemo(() => {
    if (canEditRestrictedOrgFields) return true;
    if (!roles.includes(ROLES.ORG_ADMIN)) return false;

    return me?.organizations.includes(organization.name);
  }, [canEditRestrictedOrgFields, roles, me?.organizations, organization.name]);

  const handleAccept = (updated: Organization) => {
    if (canEdit) {
      updateOrganization(
        canEditRestrictedOrgFields
          ? updated
          : { ...updated, member: organization.member },
      );
    }
  };

  return (
    <ButtonWithDialog<Organization>
      icon={canEdit ? "edit" : "eye-open"}
      minimal
      intent="none"
      defaultContent={organization}
      onAccept={handleAccept}
      disableAccept={canEdit && isInvalid}
      form={({ content, onUpdate }) => (
        <PhonebookOrganizationForm
          content={content}
          onUpdate={onUpdate}
          onValidityChange={(valid) => setIsInvalid(!valid)}
          canEditRestrictedOrgFields={canEditRestrictedOrgFields}
          readOnly={!canEdit}
        />
      )}
      hideButtons={!canEdit}
      headerTitle={canEdit ? "Edit Contact" : "Contact Info"}
    />
  );
};
